import { render } from "./OsAlteracaoPage.vue?vue&type=template&id=807497c0"
import script from "./OsAlteracaoPage.vue?vue&type=script&lang=js"
export * from "./OsAlteracaoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__